import { createGlobalState } from 'react-hooks-global-state';

const initialState = {
  count: 0,
  onQrDetailPage: false,
  isActive: '',
  exitScanner: false,
  sideDrawState: false,
  loadingState: true,
  rangeType: localStorage.getItem('RANGE_TYPE') || 'TODAY',
  dataFetch: 'FETCHING_DATA',
  complianceCardOrgID: '',
  pageNumber: 0,
  complianceINVListHeader: {
    branchName: '',
    gstinOrgName: '',
    gstin: '',
  },
  DownloadSuccess: false,
  feedBackSuccess:false,
};
export const { useGlobalState } = createGlobalState(initialState);
